import { FunctionComponent, useRef } from "react"
import S from "./page-header.module.scss"
import ArrowDown from "../svgs/feather-arrow-down.svg"

type PageHeaderProps = {
  title: string
  scrollButton?: boolean
  /** Drop to "p" when the page's real h1 lives further down, e.g. a product name. */
  as?: "h1" | "p"
}

const PageHeader: FunctionComponent<PageHeaderProps> = ({
  title,
  scrollButton = true,
  as: Title = "h1",
}) => {
  const sectionEl = useRef<HTMLElement>(null)

  const handleScroll = () => {
    if (sectionEl.current && sectionEl.current.nextSibling) {
      const nextSection = sectionEl.current.nextSibling as HTMLElement
      nextSection.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <section className={S.wrapper} ref={sectionEl}>
      <div className="container">
        <Title className={S.title}>{title}</Title>

        {scrollButton && (
          <button
            type="button"
            className={S.scrollButton}
            onClick={handleScroll}
            aria-label="Scroll down"
          >
            <ArrowDown />
          </button>
        )}
      </div>
    </section>
  )
}

export default PageHeader
